import { Modal } from 'antd';
import classNames from 'classnames';
import { orderBy } from 'lodash-es';
import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import { getLocalSoft, removeUninstall } from '../../actions/native';
import {
  addUninstall,
  cancelUninstall,
  getMixBatchDetails,
  getUninstallCategory,
  setResidualList,
  setTempResidualList,
} from '../../actions/uninstall';
import Loading from '../../components/Loading/Loading';
import { CONTEXT } from '../../config';
import { PCStoreJsBridge } from '../../nativeapi';
import { getParamString2, getQueryString2, logNative, sumAll } from '../../utils/utils';
import Category from './Category';
import ResidualSoftList from './ResidualSoftList';
import styles from './Uninstall.module.less';
import UninstLineCard from './UninstLineCard';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectInstalledSoft = createSelector(
  state => state.native,
  native => native.installedSoft,
);

const selectLocalSoftsInit = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);

const selectCategoryList = createSelector(
  state => state.uninstall,
  uninstall => uninstall.categoryList,
);
const selectResidualList = createSelector(
  state => state.uninstall,
  uninstall => uninstall.residualList,
);
const selectTempResidualList = createSelector(
  state => state.uninstall,
  uninstall => uninstall.tempResidualList,
);

const selecttMixBatchDetails = createSelector(
  state => state.uninstall,
  uninstall => {
    return uninstall.softsDetail;
  },
);
const selectCommandLine = createSelector(
  state => state.native,
  native => native.commandLine,
);
const selectUninstallSoft = createSelector(
  state => state.native,
  native => native.uninstallSoft,
);

function handleOrderBy(arr, params) {
  if (params === 'time') {
    return orderBy(arr, ['sortTime', 'sortSize'], ['desc']);
  }
  return orderBy(arr, ['sortSize', 'sortTime'], ['desc']);
}

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const installedSoft = useSelector(selectInstalledSoft);
  const installedSoftInit = useSelector(selectLocalSoftsInit);

  const [andInstalledShow, setAndInstalledShow] = useState([]);
  const [andInstalled, setAndInstalled] = useState([]);
  const [pcInstalled, setPcInstalled] = useState([]);
  const [pcInstalledShow, setPcInstalledShow] = useState([]);
  const [categorys, setCategorys] = useState([]);
  const [pcCategorySofts, setPcCategorySofts] = useState({});
  const [andCategorySofts, setAndCategorySofts] = useState({});
  const [activeCategory, setActiveCategory] = useState('all_zw');
  const [loading, setLoading] = useState(true);
  const tempResidualIconRef = useRef();
  const tempResidualListRef = useRef();
  const [forceUninstall, setForceUninstall] = useState(null);

  const [sortMenu, setSortMenu] = useState('time'); // 排序方式

  const categoryList = useSelector(selectCategoryList);
  const residualList = useSelector(selectResidualList);
  const tempResidualList = useSelector(selectTempResidualList);
  const uninstallSoftList = useSelector(selectUninstallSoft);
  const [tempResidualIcon, setTempResidualIcon] = useState(null);
  const mixBatchDetails = useSelector(selecttMixBatchDetails);
  const commandLine = useSelector(selectCommandLine);
  const history = useHistory();
  const location = useLocation();

  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `Mysofts`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
          },
        }),
      );
    };
  }, []);

  // 判断是不是右键调入该页面，需要定位到某一页面
  useEffect(() => {
    if (!commandLine || pcInstalledShow.length < 1) {
      return;
    }
    const rollPosition = () => {
      const lnkTargetUrl = getQueryString2('lnkTarget', location.search) || '';
      if (!lnkTargetUrl) {
        return;
      }
      const lnkTarget = getParamString2('lnkTarget', commandLine) || '';
      if (lnkTarget && pcInstalledShow && pcInstalledShow.length > 0) {
        PCStoreJsBridge.getSoftwareAndBits({ lnkTarget }).then(res => {
          if (res.succ) {
            const el = document.querySelector(`[data-softtag='${res.softGUID}-${res.isx64}']`);
            const result = pcInstalledShow.find(
              item =>
                item.softGUID === res.softGUID &&
                item.isx64 === res.isx64 &&
                item.androidType !== '1',
            );
            const found = uninstallSoftList.find(
              v =>
                (result.androidType !== '1' && v.softGUID === result.softGUID) ||
                (result.androidType === '1' && v.packageName === result.packageName),
            );
            const forceRes = (result && result.title) || found ? null : result;
            setForceUninstall(forceRes);
            if (forceRes) {
              dispatch(
                logging({
                  category: 'P',
                  action: 'Uninstall_Protect',
                  label: '',
                  param2: {
                    source: 'Mysofts',
                    source_p: logInfoData.source_p,
                    source_pp: logInfoData.source_pp,
                    softid: result.softID || result.SoftID || result.softid,
                    type: 'right_uninstall',
                  },
                }),
              );
            }
            if (el) {
              el.scrollIntoView({ block: 'center' });
              history.replace(`${CONTEXT}/uninstall`);
            }
          }
        });
      }
    };
    const timer = setTimeout(() => {
      rollPosition();
      clearTimeout(timer);
    }, 400);
    // eslint-disable-next-line consistent-return
    return () => {
      clearTimeout(timer);
    };
  }, [mixBatchDetails, installedSoft, commandLine, pcCategorySofts, uninstallSoftList]);

  useEffect(() => {
    tempResidualIconRef.current = tempResidualIcon;
    tempResidualListRef.current = tempResidualList;
  });

  useEffect(() => {
    setLoading(false);
  }, [mixBatchDetails, categoryList]);

  useEffect(() => {
    // if (mixBatchDetails && mixBatchDetails.length > 0 && !tempResidualIconRef.current) {
    if (mixBatchDetails && mixBatchDetails.length > 0) {
      const obj = {};
      mixBatchDetails.forEach(item => {
        obj[item.softID] = item;
      });
      setTempResidualIcon({ ...obj });
    }
  }, [mixBatchDetails]);
  // 根据软件的softid和包名获取各个软件的分类
  const handleMixBatchers = (pcInstalleds = [], andInstalleds = []) => {
    if (pcInstalleds.length === 0 && andInstalleds.length === 0) {
      return;
    }
    dispatch(
      getMixBatchDetails({
        params: {
          softIds: pcInstalleds.map(item => item.SoftID).filter(item => item),
          pns: andInstalleds.map(item => item.packageName).filter(item => item),
        },
      }),
    );
  };

  // 获取残留文件列表
  useEffect(() => {
    PCStoreJsBridge.getSoftwareListResidual().then(res => {
      if (res) {
        dispatch(
          setResidualList(
            res.residualList
              .map(soft => ({
                ...soft,
                SoftID: soft.softid,
                source: 'residualList',
                status: 'init',
                percent: 0,
                hasResidual: true,
              }))
              .filter(item => item.totalSize <= 200 * 1024 * 1024),
          ),
        );
      }
    });
  }, []);

  // 订阅软件卸载扫描残留消息、卸载消息、安卓卸载消息
  useEffect(() => {
    PCStoreJsBridge.subscribeMessage(msg => {
      if (msg.getMsgcategory() === 'APKS_NT_UNINSTALL_DONE') {
        const ret = PCStoreJsBridge.arrayToUTF8String(msg.getMessageproto());
        try {
          const retJson = JSON.parse(ret);
          logNative(`通知 APKS_NT_UNINSTALL_DONE 卸载状态${ret}`, retJson, true, true);
          // 卸载成功
          if (retJson.succ === 'true') {
            // 不再获取安装列表，成功直接从当前列表移除
            dispatch(
              removeUninstall({
                ...retJson,
                androidType: '1',
                packageName: retJson.pkg,
              }),
            );
          }
          // 卸载失败或取消卸载，删除卸载任务
          dispatch(
            cancelUninstall({
              ...retJson,
              androidType: '1',
              packageName: retJson.pkg,
            }),
          );
          // setUninstallSoft(null);
        } catch (error) {
          logNative(`通知 APKS_NT_UNINSTALL_DONE JSON 解析错误${error}`, error);
        }
      }
    });
  }, [dispatch]);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const and_installed = [];
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const pc_installed = [];
    installedSoft.forEach(soft => {
      if (soft && soft.androidType === '1') {
        and_installed.push(soft);
      }

      // soft.softGUID === 'LEmu' ||
      // soft.displayName.indexOf('联想应用融合引擎') > -1 ||
      if (soft && soft.androidType !== '1' && soft.canUninst) {
        if (
          !(
            soft.displayName === '' ||
            soft.SoftID === '"L80050"' ||
            soft.softGUID === 'Lenovo SLBrowser' ||
            soft.displayName.indexOf('联想浏览器') > -1 ||
            soft.softGUID === 'Microsoft Edge' ||
            soft.SoftID === '"26342"' ||
            soft.displayName.indexOf('microsoft edge') > -1 ||
            soft.displayName.indexOf('Edge') > -1 ||
            (soft.displayName &&
              soft.displayName.replace(/\s+/g, '').indexOf('联想软件商店') > -1) ||
            soft.softGUID === 'LenovoAppStore_is1' ||
            soft.softID === 'L100072' ||
            soft.displayName.indexOf('联想电脑管家') > -1 ||
            soft.softGUID === '{A9861883-31C5-4324-BD9A-DC9527EEB675}_is1'
          )
        ) {
          pc_installed.push(soft);
        }
      }
    });
    setAndInstalled(and_installed);
    setPcInstalled(pc_installed);
    handleMixBatchers(pc_installed, and_installed);
  }, [dispatch, installedSoft]);

  /**
   * 统计不可卸载的应用
   */
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const cant_open_soft = [];
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const all_soft = [];
    installedSoftInit.forEach(soft => {
      const target =
        mixBatchDetails.find(item => item.softID === soft.SoftID && item.androidType !== '1') || {};
      if (soft && soft.androidType !== '1' && soft.canUninst && !soft.MainExePath) {
        cant_open_soft.push({
          softGUID: soft.softGUID,
          softID: soft.SoftID,
          softName: soft.displayName,
          version: soft.displayVersion,
          category: target.myTags,
        });
      }
      all_soft.push({
        softGUID: soft.softGUID,
        softID: soft.SoftID,
        softName: soft.displayName,
        version: soft.displayVersion,
        category: target.myTags,
      });
    });
    if (cant_open_soft.length > 0) {
      dispatch(
        logging({
          category: 'I',
          action: 'Mysofts_Cant_Open',
          label: '',
          param2: {
            source: 'Mysofts',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            cantOpenSoft: cant_open_soft,
            allSoft: all_soft,
          },
        }),
      );
    }
  }, [dispatch, installedSoftInit, mixBatchDetails]);

  useEffect(() => {
    // 卸载页-卸载页页面呈现-打桩 PV
    dispatch(
      logging({
        category: 'P',
        action: 'Mysofts',
        label: '',
        param2: {
          source: 'Mysofts',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'Mysofts',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  }, [dispatch]);

  // 获取本地安装的软件
  useEffect(() => {
    dispatch(getLocalSoft());
  }, []);

  // 点击查看更多软件
  const handleShowMore = useCallback(flag => {
    if (flag) {
      setAndInstalledShow(andCategorySofts[activeCategory] || []);
    } else {
      setAndInstalledShow(
        (andCategorySofts[activeCategory] && andCategorySofts[activeCategory].slice(0, 3)) || [],
      );
    }
  });

  const handleSort = useCallback(flag => {
    // 清空以防止乱序后卸载中的状态不正确
    const handleSortByType = params => {
      // 处理pc软件
      const pcSofts = {};

      Object.keys(pcCategorySofts).forEach(key => {
        pcSofts[key] = handleOrderBy(pcCategorySofts[key], params);
      });
      setPcCategorySofts(pcSofts);
      setPcInstalledShow(handleOrderBy(pcInstalledShow, params));
      // 处理安卓软件
      const andSofts = {};
      Object.keys(andCategorySofts).forEach(key => {
        andSofts[key] = handleOrderBy(andCategorySofts[key], params);
      });
      setAndCategorySofts(andSofts);
      setAndInstalledShow(handleOrderBy(andInstalledShow, params));
    };
    if (flag === 'time') {
      handleSortByType('time');
    } else if (flag === 'size') {
      handleSortByType('size');
    }
    setSortMenu(flag);

    // 卸载页-切换排序方式
    dispatch(
      logging({
        category: 'C',
        action: 'Mysofts_Sort',
        label: '',
        param2: {
          type: flag,
          source: 'Mysofts',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  });

  // v6.1 20200907 zw
  // 点击标签分类
  const handleActiveCategory = useCallback(
    (active = 'all_zw', vpcCategorySofts, vandCategorySofts) => {
      if (!vpcCategorySofts) {
        // eslint-disable-next-line no-param-reassign
        vpcCategorySofts = pcCategorySofts;
      }
      if (!vandCategorySofts) {
        // eslint-disable-next-line no-param-reassign
        vandCategorySofts = andCategorySofts;
      }
      setActiveCategory(active);
      if (active === 'residual') {
        setPcInstalledShow([]);
        setAndInstalledShow([]);
      }
      setPcInstalledShow(() => {
        if (!installedSoft) {
          return;
        }
        // eslint-disable-next-line consistent-return
        return vpcCategorySofts[active] || [];
      });
      setAndInstalledShow(() => {
        if (!installedSoft) {
          return;
        }
        // eslint-disable-next-line consistent-return
        return (vandCategorySofts[active] && vandCategorySofts[active].slice(0, 3)) || [];
      });
    },
  );
  useEffect(() => {
    dispatch(setTempResidualList([]));
    dispatch(setResidualList([]));
  }, []);
  //  处理请求获取标签
  useEffect(() => {
    dispatch(getUninstallCategory());
  }, []);

  useEffect(() => {
    const recordObj = {};
    const andRecordObj = {};
    if (categoryList && mixBatchDetails) {
      // 处理pc软件
      const tempList = tempResidualListRef.current.filter(
        item => !pcInstalled.find(soft => item.softGUID === soft.softGUID),
      );
      // setPcInstalled([...pc_installed, ...tempList]);
      [...pcInstalled, ...tempList].forEach(soft => {
        const categoryInfo = mixBatchDetails.find(
          item => item.softID === soft.SoftID && soft.androidType !== '1',
        );
        const detail = {
          ...soft,
          title: categoryInfo && categoryInfo.title,
          userGrade: categoryInfo && categoryInfo.userGrade,
        };
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        categoryInfo && categoryInfo.logoFile && (detail.logoFile = categoryInfo.logoFile);
        if (categoryInfo && categoryInfo.myTags) {
          categoryInfo.myTags.forEach(item => {
            if (recordObj[item]) {
              recordObj[item].push(detail);
            } else {
              recordObj[item] = [detail];
            }
          });
        } else if (recordObj['9999']) {
          recordObj['9999'] = [...recordObj['9999'], detail];
        } else {
          recordObj['9999'] = [detail];
        }
      });
      recordObj.all_zw = Object.keys(recordObj).reduce((result, key) => {
        const temp = [];
        recordObj[key].forEach(arr => {
          if (!result.find(item => item.SoftID === arr.SoftID)) {
            temp.push(arr);
          }
        });
        return [...result, ...temp];
      }, []);

      // 处理安卓软件
      // andCategorySofts
      andInstalled.forEach(soft => {
        const categoryInfo = mixBatchDetails.find(
          item => item.packageName === soft.packageName && soft.androidType === '1',
        );
        const detail = {
          ...soft,
          title: categoryInfo && categoryInfo.title,
          userGrade: categoryInfo && categoryInfo.userGrade,
        };
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        categoryInfo && categoryInfo.logoFile && (detail.logoFile = categoryInfo.logoFile);
        if (categoryInfo && categoryInfo.myTags) {
          categoryInfo.myTags.forEach(item => {
            if (andRecordObj[item]) {
              andRecordObj[item].push(detail);
            } else {
              andRecordObj[item] = [detail];
            }
          });
        } else if (andRecordObj['9999']) {
          andRecordObj['9999'] = [...andRecordObj['9999'], detail];
        } else {
          andRecordObj['9999'] = [detail];
        }
      });
      andRecordObj.all_zw = Object.keys(andRecordObj).reduce((result, key) => {
        const temp = [];
        andRecordObj[key].forEach(arr => {
          if (!result.find(item => item.packageName === arr.packageName)) {
            temp.push(arr);
          }
        });
        return [...result, ...temp];
      }, []);

      // 剔除无效的category分类标签
      setCategorys(categoryList.filter(item => recordObj[item.id] || andRecordObj[item.id]));
      Object.keys(recordObj).forEach(key => {
        recordObj[key] = handleOrderBy(recordObj[key], 'time');
      });
      setPcCategorySofts(() => {
        // // 保存完整的以分类id为key的数据

        return recordObj;
      });
      Object.keys(andRecordObj).forEach(
        // eslint-disable-next-line no-return-assign
        key => {
          andRecordObj[key] = handleOrderBy(andRecordObj[key], 'time');
        },
      );
      setAndCategorySofts(() => {
        return andRecordObj;
      });
      let active = activeCategory;
      if (active === 'residual') {
        return;
      }
      if (
        (!recordObj[activeCategory] || recordObj[activeCategory].length === 0) &&
        (!andRecordObj[activeCategory] || andRecordObj[activeCategory].length === 0)
      ) {
        active = 'all_zw';
      }
      setActiveCategory(active);
      handleActiveCategory(active, recordObj, andRecordObj);
    }
  }, [categoryList, mixBatchDetails, pcInstalled, andInstalled]);
  const handleForceUninstall = useCallback(() => {
    // 确认打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Uninstall_Protect_Continue',
        label: '',
        param2: {
          source: 'Mysofts',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: 'right_uninstall',
          softid: forceUninstall.softID || forceUninstall.SoftID || forceUninstall.softid,
          softname: forceUninstall.softName,
        },
      }),
    );
    dispatch(addUninstall(forceUninstall));
    PCStoreJsBridge.uninstallSoft(forceUninstall);
    setForceUninstall(null);
  }, [forceUninstall]);

  const handleClose = useCallback(
    type => {
      // 取消或者关闭打桩
      dispatch(
        logging({
          category: 'C',
          action: type === 'close' ? 'Uninstall_Protect_Close' : 'Uninstall_Protect_Cancel',
          label: '',
          param2: {
            source: 'Mysofts',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            type: 'right_uninstall',
            softid: forceUninstall.softID || forceUninstall.SoftID || forceUninstall.softid,
            softname: forceUninstall.softName,
          },
        }),
      );
      setForceUninstall(null);
    },
    [forceUninstall],
  );

  if (loading) {
    return (
      <div
        style={{ height: '600px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <Loading />
      </div>
    );
  }

  return (
    <>
      <div className={styles.mysoftware}>
        <div className={styles.category_box}>
          <div className="mysoftware_header">
            <div className="header_text">
              已安装
              <span className="totalNumberText">
                {' '}
                {andInstalled.length + pcInstalled.length + residualList.length}{' '}
              </span>
              款软件，共占用硬盘
              <span className="totalMemoryText"> {sumAll(installedSoft)}</span>
            </div>
            <div className={styles.header_menu}>
              <div className={classNames(styles.menu_text, styles.menu_active, styles.menu_show)}>
                {sortMenu === 'time' ? '安装时间' : '软件大小'}
                <i
                  className={classNames(
                    'iconfont',
                    styles.menu_text,
                    styles.menu_icon,
                    styles.menu_active,
                  )}
                />
              </div>
              <div className={classNames(styles.menu_modal)}>
                <div
                  className={classNames(styles.menu_text_small, {
                    [styles.menu_active]: sortMenu === 'time',
                  })}
                  onClick={() => {
                    handleSort('time');
                  }}
                >
                  安装时间
                </div>
                <div
                  className={classNames(styles.menu_text_small, {
                    [styles.menu_active]: sortMenu === 'size',
                  })}
                  onClick={() => {
                    handleSort('size');
                  }}
                >
                  软件大小
                </div>
              </div>
            </div>
          </div>

          <div className={styles.category}>
            <Category
              getActive={handleActiveCategory}
              categoryList={categorys}
              showResidual={tempResidualList.length + residualList.length > 0}
            />
          </div>
        </div>
        {andCategorySofts[activeCategory] && andCategorySofts[activeCategory].length > 0 && (
          <React.Fragment>
            <div className="mysoftware_title" style={{ marginTop: '25px' }}>
              <i className="icon iconfont icon-Android" />
              <span>
                安卓软件
                {`（${(andCategorySofts[activeCategory] &&
                  andCategorySofts[activeCategory].length) ||
                  ''}）`}
              </span>
            </div>
            <div className="mysoftware_softlist" style={{ marginTop: '14px' }}>
              {andInstalledShow.map((soft, i) => (
                <UninstLineCard
                  soft={soft}
                  logInfo={{}}
                  key={`${i}_${activeCategory}_${soft.packageName}`}
                />
              ))}
              {andCategorySofts[activeCategory] && andCategorySofts[activeCategory].length > 3 && (
                <React.Fragment>
                  {andCategorySofts[activeCategory] &&
                    andCategorySofts[activeCategory].length > andInstalledShow.length && (
                      <div
                        className="softlist_show_more"
                        onClick={() => {
                          handleShowMore(true);
                        }}
                      >
                        <div className="softlist_show_all">查看全部</div>
                        <span className="arrow_icon_down" />
                      </div>
                    )}
                  {andCategorySofts[activeCategory] &&
                    andCategorySofts[activeCategory].length === andInstalledShow.length && (
                      <div
                        className="softlist_show_more"
                        onClick={() => {
                          handleShowMore(false);
                        }}
                      >
                        <div className="softlist_show_less">收起</div>
                        <span className="arrow_icon_up" />
                      </div>
                    )}
                </React.Fragment>
              )}
            </div>
          </React.Fragment>
        )}
        {((activeCategory === 'all_zw' && pcInstalledShow.length > 0) ||
          (activeCategory === 'residual' &&
            (residualList.length > 0 || tempResidualList.length > 0)) ||
          (activeCategory !== 'residual' &&
            activeCategory !== 'all_zw' &&
            pcInstalledShow.length > 0)) && (
          <React.Fragment>
            <div className="mysoftware_title_pc" style={{ marginTop: '25px' }}>
              <i className="icon iconfont icon-PC" />
              <span>
                电脑软件
                {`（${(activeCategory !== 'residual' ? pcInstalledShow.length : 0) +
                  (activeCategory === 'residual' || activeCategory === 'all_zw'
                    ? residualList.length
                    : 0) +
                  (activeCategory === 'residual' ? tempResidualList.length : 0)}）`}
              </span>
            </div>
            <div className="mysoftware_softlist softlist_pc" style={{ marginTop: '14px' }}>
              {pcInstalledShow.map((soft, i) => (
                <UninstLineCard
                  soft={soft}
                  logInfo={{}}
                  key={`${i}_${activeCategory}_${soft.SoftID}`}
                  tempResidualList={tempResidualList}
                  softInfo={tempResidualIcon}
                />
              ))}
              {(activeCategory === 'all_zw' || activeCategory === 'residual') &&
                installedSoft &&
                installedSoft.length > 0 &&
                Object.keys(pcCategorySofts).length > 0 && (
                  <ResidualSoftList
                    activeCategory={activeCategory}
                    mixBatchDetails={mixBatchDetails}
                  />
                )}
            </div>
          </React.Fragment>
        )}

        <Modal
          visible={!!forceUninstall}
          style={{
            position: 'fixed',
            top: '250px',
            left: 'calc(50% - 180px)',
            zIndex: 1000,
            width: '360px',
            height: '180px',
            padding: '12px 15px',
            background: '#fff',
            boxShadow: '0px 3px 10px 0px rgba(0, 0, 0, 0.3)',
            borderRadius: '4px',
            boxSizing: 'border-box',
          }}
          bodyStyle={{
            padding: 0,
          }}
          maskStyle={{
            backgroundColor: 'transparent',
          }}
          wrapClassName={styles.modalWrap}
          mask
          maskClosable={false}
          width={360}
          centered
          destroyOnClose
          footer={null}
          closable={false}
        >
          <div className={styles.modal_header}>
            <span className={styles.title}>温馨提示</span>
            <i
              className={classNames('iconfont icon-close', styles.icon_close)}
              onClick={() => {
                handleClose('close');
              }}
            />
          </div>
          <div className={styles.modal_content}>
            您确定要卸载
            <div className={styles.soft_name}>{forceUninstall && forceUninstall.displayName}</div>
            吗？
          </div>
          <div className={styles.modal_button}>
            <div
              className={classNames(styles.button, styles.uninstall)}
              onClick={handleForceUninstall}
            >
              立即卸载
            </div>
            <div className={classNames(styles.button, styles.install)} onClick={handleClose}>
              取消卸载
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
});
